module.exports = __webpack_public_path__ + "img/1106a_5.7180cd8d.jpg";